import { find, path, propEq } from 'ramda';
import { createSelector } from 'reselect';

// State selectors
export const selectRailways = state => path(['api', 'railway', 'data'], state) || [];

// Prop selectors
export const selectRailwayIdFromProps = (state, props) => path(['id'], props);

// Memoize selectors
export const selectRailwayById = createSelector(
  [selectRailways, selectRailwayIdFromProps],
  (railways, railwayId) => find(propEq('id', railwayId))(railways),
);
